import ResourceMessages from '@/zenky/resources/ResourceMessages';
import ProductVariant from '@/zenky/interfaces/products/ProductVariant';

export default class ProductVariantMessages extends ResourceMessages {
  confirm(variant: ProductVariant): string {
    return 'Вы уверены, что хотите удалить этот вариант?';
  }
}
